/** Labels like "04:00 PM" for hours 0–23; plus week-start midnight default. */
export const WEEKLY_GROSS_RESET_WEEK_START = "Week start midnight";

export function formatWeeklyGrossResetHourLabel(hour) {
    if (hour === null || hour === undefined || hour === "") {
        return WEEKLY_GROSS_RESET_WEEK_START;
    }
    const h = Number(hour);
    if (!Number.isInteger(h) || h < 0 || h > 23) {
        return WEEKLY_GROSS_RESET_WEEK_START;
    }
    const period = h < 12 ? "AM" : "PM";
    let display = h % 12;
    if (display === 0) display = 12;
    const padded = String(display).padStart(2, "0");
    return `${padded}:00 ${period}`;
}

export function weeklyGrossResetHourDataset() {
    const hours = [];
    for (let h = 0; h <= 23; h++) {
        hours.push(formatWeeklyGrossResetHourLabel(h));
    }
    return [WEEKLY_GROSS_RESET_WEEK_START, ...hours];
}

/** Map select label → Integer hour or null (week-start midnight). */
export function parseWeeklyGrossResetHourLabel(label) {
    if (label == null || label === "" || label === WEEKLY_GROSS_RESET_WEEK_START) {
        return null;
    }
    for (let h = 0; h <= 23; h++) {
        if (formatWeeklyGrossResetHourLabel(h) === label) {
            return h;
        }
    }
    return null;
}
